import React from "react";
import { Typography } from "material-ui";
import { formatDateTimeString } from "./../../../utilities/datesFormatter";
import OrdenTrabajoImage from "./../../../images/ordentrabajo_consulta.png";

const fakeData = {
  Nombre: "Orden de trabajo 1",
  Fecha: "2017-08-29 00:46:16",
  Estatus: "Configurada",
  Unidad: "TRA 01"
};

const OrdenTrabajoTile = props => {
  const data = { props };
  const dateTime = formatDateTimeString(fakeData.Fecha);

  return (
    <div className="dashboard-tile">
      <div className="tile-header">Próxima orden de trabjo</div>
      <div className="tile-body">
        <Typography
          variant="display1"
          align="center"
          color="textSecondary"
          className="headline"
        >
          <img style={{ width: "2.5rem" }} src={OrdenTrabajoImage} />
        </Typography>
        <Typography
          variant="display1"
          align="center"
          color="textSecondary"
          className="headline"
        >
          {dateTime[0]}
        </Typography>
        <Typography
          variant="subheading"
          align="center"
          color="textSecondary"
          className="headline"
        >
          {dateTime[1]}
        </Typography>
      </div>
      <div className="tile-footer">
        <Typography
          variant="title"
          align="center"
          color="primary"
          className="headline"
        >
          {fakeData.Unidad}
        </Typography>
        <Typography
          variant="subheading"
          align="center"
          color="textSecondary"
          className="headline"
        >
          {fakeData.Nombre}
        </Typography>
        <Typography
          variant="subheading"
          align="center"
          color="textSecondary"
          className="headline"
        >
          {fakeData.Estatus}
        </Typography>
      </div>
    </div>
  );
};

export default OrdenTrabajoTile;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardTiles/OrdenTrabajoTile.js